<!-- <mat-menu #notification="matMenu" class="notification-menu">
    <div class="d-flex text-center justify-content-start text-capitalize m-3">
      <h2 class="notification-header">notifications</h2>
    </div>
    <mat-divider></mat-divider>
    <mat-list role="list" class="notification-mat-list" *ngIf = "notificationData.totalCount != 0">
        <ng-container *ngFor = "let data of notificationData.dataList; let index = index">
          <mat-list-item class="notification-mat-list-item pointer" (click) = "navigateMeeting(data.meetingId)">
            <div>
              <button class="mat-margin-3px global-icn-bttn-container" *ngIf = "data['notificationType'] == 'M'" color = "primary" mat-mini-fab tooltip = "Meeting" color = "primary" placement = "right" triggers = "hover"><mat-icon class = "global-icn-size assignment">meeting_room</mat-icon></button>
              <button class="mat-margin-3px global-icn-bttn-container" *ngIf = "data['notificationType'] == 'T'" mat-mini-fab tooltip = "Task" triggers = "hover"><mat-icon class = "global-icn-size assignment">assignment</mat-icon></button>
            </div>
            <div class="mar-l-10px">
              <h5 class="margin-0 notification-title">
                {{data['notificationTitle']}}
              </h5>
              <h6 class="margin-0 notification-sub-title"><span *ngIf = "data['notificationType'] != 'M'"> Due on </span>{{data['date']}}</h6>
            </div>
          </mat-list-item>
          <mat-divider *ngIf = "index + 1 != notificationJSON.length"></mat-divider>
        </ng-container>
    </mat-list>
    <ng-container *ngIf = "notificationData.totalCount == 0">
      <mat-list>
        <h4 class="margin-0 notification-no-record">No Records Found</h4>
      </mat-list>
    </ng-container>
</mat-menu> -->
<button [matMenuTriggerFor]="notification" class="parent allowAfterApprove" mat-icon-button aria-label="Example icon-button with heart icon" tooltip="Notification" triggers="hover">
    <!-- <mat-icon matBadgeColor="primary">notifications_none</mat-icon> -->
    <ng-content select = "[icon]"></ng-content>
</button>
<mat-menu #notification="matMenu" class="notification-menu">
    <div class="d-flex text-center justify-content-start text-capitalize m-3">
        <ng-content select = "[menu-title]"></ng-content>
    </div>
    <mat-divider></mat-divider>
    <mat-tab-group animationDuration="0ms" (click)="$event.stopPropagation();">
      <mat-tab origin = "0" label={{labelOne}}>
        <ng-template mat-tab-label>
          <span class="badge-bg badge-cl">{{labelOneBadge}}</span>
          <span class="ml-10">{{labelOne}}</span>
        </ng-template>
        <div>
          <ng-content select = '[labelOne]'></ng-content>
        </div>
      </mat-tab>
      <mat-tab label={{labelTwo}}>
        <ng-template mat-tab-label>
          <span class="badge-bg badge-cl">{{labelTwoBadge}}</span>
          <span class="ml-10">{{labelTwo}}</span>
        </ng-template>
        <div>
          <ng-content select = '[labelTwo]'></ng-content>
        </div>
      </mat-tab>
    </mat-tab-group>
</mat-menu> 